var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pricesAlwaysWithTax !== "1"
    ? _c("div", { staticClass: "vat-toggle" }, [
        _c("label", { staticClass: "vat-toggle__label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.vat,
                expression: "vat"
              }
            ],
            staticClass: "checkbox-input vat-toggle__checkbox-input",
            attrs: {
              type: "checkbox",
              value: "true",
              "aria-disabled": _vm.$store.getters.isOffer,
              disabled: _vm.$store.getters.isOffer
            },
            domProps: {
              checked: Array.isArray(_vm.vat)
                ? _vm._i(_vm.vat, "true") > -1
                : _vm.vat
            },
            on: {
              change: function($event) {
                var $$a = _vm.vat,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = "true",
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.vat = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.vat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.vat = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "checkbox-label vat-toggle__checkbox-label" },
            [_vm._v(_vm._s(_vm.$modeoL10n.show_prices_including_tax))]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc743020", { render: render, staticRenderFns: staticRenderFns })
  }
}